import { useAuth } from '../../context/AuthContext';
import { ChattingShell, useChattingData, usePeriod, PREV_LABEL } from './ChattingShell';
import { ChatterHeadline, ChatterDetailGrid } from './ChatterStatCards';

export const ChatterDashboard = () => {
  const { user } = useAuth();
  const period = usePeriod();
  const { timeframe } = period;
  const { data, error, loading } = useChattingData('me', period);

  const notMapped = data && !data.mapped;
  return (
    <ChattingShell title="Dashboard" subtitle={`Welcome back, ${user?.name}`} period={period}
      error={error} fetchedAt={data?.fetched_at} stale={data?.stale}>
      {loading && !data ? <div className="text-zinc-400">Loading...</div> : notMapped ? (
        <div className="bg-card p-6 rounded-md border border-border text-zinc-400" data-testid="chatter-not-linked">
          Your account is not linked to a Fanvue chatter yet. Ask your admin to link it.
        </div>
      ) : (
        <>
          <ChatterHeadline s={data?.stats} prev={data?.previous} prevLabel={PREV_LABEL[timeframe]} ratePercent={data?.rate_percent} />
          <ChatterDetailGrid s={data?.stats} />
          {data?.stats?.by_creator?.length > 1 && (
            <div className="bg-card p-5 rounded-md border border-border" data-testid="chatter-by-creator">
              <div className="text-xs uppercase tracking-wider text-zinc-400 font-semibold mb-3">Sales by model</div>
              {data.stats.by_creator.map((b, i) => (
                <div key={i} className="flex justify-between text-sm py-1.5 border-b border-zinc-800 last:border-0">
                  <span className="text-zinc-300">{b.creator_name}</span>
                  <span className="text-white tabular-nums">${(b.ppv_revenue + b.tips_revenue - b.chargeback_amount).toFixed(2)}</span>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </ChattingShell>
  );
};
